// #region imports
import React, {  Component }      from 'react';
import PropTypes        from 'prop-types';
import cx               from 'classnames';
import { Link }         from 'react-router-dom';
import auth                   from '../../../../../../services/auth';
import { withRouter }           from 'react-router';
import {aclUtil} from "../../../../../../views/util"

class ViewLink extends Component {
  constructor(props){
    super(props);

  }
  static propTypes = {
    isActive:   PropTypes.bool,
    viewName:   PropTypes.string.isRequired,
    linkTo:     PropTypes.string.isRequired,
    faIconName: PropTypes.string.isRequired,
    itemCount:  PropTypes.number
  };

  static defaultProps = {
    isActive: false
  };

  onHandleChanged(linkKey) {
    const userinfo = auth.getUserInfo();
    let userTypeName = localStorage.getItem("userTypeName");
    if(userinfo && userinfo.userTypeName == 'subadmin')
    {
      if(!aclUtil.isPrimaryMenuAccessible(linkKey)){
        this.props.history.push("/restrictedAccess");
      }
    }
  }

  render() {
    const { isActive, linkTo, linkKey, viewName, itemCount, faIconName } = this.props;
    let siteData = JSON.parse(localStorage.getItem('siteDDBStatus'));
    let userTypeName = localStorage.getItem("userTypeName");
    let defaultStyle;
    let activeIcon;
    if((userTypeName == 'merchant' && siteData.activeMerchant == 'Active' && viewName == 'Announcements' ) || (userTypeName == 'subadmin' && siteData.activeSubadmin == 'Active' && viewName == 'Announcements')){
      defaultStyle = {fontSize: '13px', marginLeft: '5px',  color: 'red' }
      activeIcon = {lineHeight: '18px',color:'red'}
    }else if((viewName == 'Announcements' && userTypeName == 'subadmin' && siteData.activeSubadmin == 'In-Active' ) || ( viewName == 'Announcements' && userTypeName == 'merchant' && siteData.activeMerchant == 'In-Active' ) || ( viewName == 'Announcements' && siteData.activeAnnouncementsAll == 'In-Active' )){
      defaultStyle = {display: 'none'}  
      activeIcon = {display: 'none'}  
    }else{
      defaultStyle = {fontSize: '13px', marginLeft: '5px', color: viewName == 'Announcements' ? 'red' : ''}    
      activeIcon = {lineHeight: '18px', color: viewName == 'Announcements' ? 'red' : ''}
    }

    return (
        <Link className="btn" to={linkTo} onClick={this.onHandleChanged.bind(this, linkKey)} replace>
          <i className={`fa pull-left ${faIconName} check`} style={activeIcon} />
            <span  className="sidebar-menu__group-title" style={defaultStyle}>
              {viewName}
            </span>
            {itemCount > 0 &&
              <span className="label label-primary pull-right">
                {itemCount}
              </span>
            }
        </Link>
      );
  }

}

export default (withRouter)(ViewLink);


// WEBPACK FOOTER //
// ./src/app/components/aside/asideLeft/menu/menuLinks/viewLink/ViewLink.js